import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodPressureAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-non-invasive-blood-pressure-slot',
    templateUrl: './non-invasive-blood-pressure-slot.component.html',
    styleUrl: './non-invasive-blood-pressure-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodPressureSlotComponent implements SheetSlotComponentBase {

	action!: BloodPressureAction;
	value!: string | null;

	@Input('action') set updateAction(action: BloodPressureAction | null) {
		this.action = action as BloodPressureAction;
		this.value = this.action.systolic?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}
